
import CardContenedor from "../components/CardContenedor";
import { Volver } from "../components/Volver";
import useComision from "../hooks/useComision";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";
import { Toaster } from 'react-hot-toast';
import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import { Link } from 'react-router-dom'


export default function Comision({ fromAdmin = false }) {


	const objLogueado = useEmpleadoStore(state => state.objLogueado)
	const { formComision, setFormComision, jefes, cargando,
		formOrigen, setFormOrigen, setFormDestino, formDestino, guardar,
		puesto, guardando, show } = useComision()
	if (!objLogueado.permitido) {
		window.location = "/"
		return (<></>)
	}


	// if (fromAdmin) {
	//     return <ComponenteGrande/>
	// }

	return (
		<CardContenedor>
			<Volver />
			{/* nombre */}
			<div className='mb-2 mt-4 row d-flex flex-row'>
				<div className='col-12 col-md-5'>
					<b>Nombre:</b>
				</div>
				<div className='col-12 col-md-7'>
					{objLogueado.nombre} {objLogueado.apellido}
				</div>
			</div>

			{/* dependencia */}
			<div className='mb-2 row d-flex flex-row'>
				<div className='col-12 col-md-5'>
					<b>Área o dependencia administrativa:</b>
				</div>
				<div className='col-12 col-md-7'>
					{cargando
						? 'Cargando...'
						: <select className='form-control' defaultValue={0} onChange={e => setFormComision({ ...formComision, adscripcion: e.target.value })}>
							<option value={0} disabled>Selecciona una opción</option>
							{jefes.map((e, i) => <option key={i} value={e.pk_area}>{e.nombre_empleado} - {e.areas_adscripcion}</option>)}0
						</select>
					}
				</div>
			</div>

			{/* puesto */}
			<div className='mb-2 row d-flex flex-row'>
				<div className='col-12 col-md-5'>
					<b>Puesto:</b>
				</div>
				<div className='col-12 col-md-7'>
					{puesto}
				</div>
			</div>

			<div className='mb-2 row d-flex flex-row'>

				{/* motivo */}
				<div className='col-12 col-md-5'>
					<b>Motivo de la comisión:</b>
				</div>
				<div className='col-12 col-md-7'>
					<textarea
						rows="3"
						maxLength="255"
						className="form-control"
						placeholder='Escriba el motivo'
						defaultValue={formComision.motivo}
						id="exampleFormControlTextarea1"
						onChange={({ target: { value: motivo } }) => setFormComision({ ...formComision, motivo })}
					>
						{/* { formSalida.motivo && '' } */}
					</textarea>
				</div>


				<div className='mb-2 row d-flex flex-row'>
					<div className='col-12'>

						{/* origen */}
						<hr className="mt-5" />
						<table className='table table-sm text-center table-borderless'>
							<thead>
								<tr>
									<th colSpan={3}>Origen del encargo o comision</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>País</td>
									<td>Estado</td>
									<td>Ciudad</td>
								</tr>

								<tr>
									<td>
										<input type="text" className="form-control" placeholder='Escribe aquí'
											value={formOrigen.pais}
											onChange={e => setFormOrigen({ ...formOrigen, pais: e.target.value })}
										/>
									</td>
									<td>
										<input type="text" className="form-control" placeholder='Escribe aquí'
											value={formOrigen.estado}
											onChange={e => setFormOrigen({ ...formOrigen, estado: e.target.value })}
										/>
									</td>
									<td>
										<input type="text" className="form-control" placeholder='Escribe aquí'
											value={formOrigen.ciudad}
											onChange={e => setFormOrigen({ ...formOrigen, ciudad: e.target.value })}
										/>
									</td>
								</tr>

							</tbody>

						</table>


						{/* destino */}
						<hr className="mt-5" />
						<table className='table table-sm text-center table-borderless'>
							<thead>
								<tr>
									<th colSpan={3}>Destino del encargo o comision</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>País</td>
									<td>Estado</td>
									<td>Ciudad</td>
								</tr>

								<tr>
									<td>
										<input type="text" className="form-control" placeholder='Escribe aquí'
											value={formDestino.pais}
											onChange={e => setFormDestino({ ...formDestino, pais: e.target.value })}
										/>
									</td>
									<td>
										<input type="text" className="form-control" placeholder='Escribe aquí'
											value={formDestino.estado}
											onChange={e => setFormDestino({ ...formDestino, estado: e.target.value })}
										/>
									</td>
									<td>
										<input type="text" className="form-control" placeholder='Escribe aquí'
											value={formDestino.ciudad}
											onChange={e => setFormDestino({ ...formDestino, ciudad: e.target.value })}
										/>
									</td>
								</tr>

							</tbody>

						</table>


						{/* fechas de salida y regreso */}
						<hr className="mt-5" />
						<div className="row gx-4 gy-3">
							<div className="col-md">
								<div className="mb-3">
									<label htmlFor="fecha_salida" className="fw-bold text-end">Fecha de salida</label>
									<input
										type="date"
										className="form-control"
										id="fecha_salida"
										value={formComision.fecha_salida}
										onChange={e => setFormComision({ ...formComision, fecha_salida: e.target.value })} />
								</div>
							</div>
							<div className="col-md">
								<div className="mb-3">
									<label htmlFor="fecha_regreso" className="fw-bold text-end">Fecha de regreso</label>
									<input
										type="date"
										className="form-control"
										id="fecha_regreso"
										value={formComision.fecha_regreso}
										onChange={e => setFormComision({ ...formComision, fecha_regreso: e.target.value })} />
								</div>
							</div>
						</div>

						<div className="row gx-4 gy-3">
							{/* tipo de viaticos */}
							<div className="col-md">
								<div className="mb-3">
									<label htmlFor="tipo_viatico" className="fw-bold text-end">Tipo de viáticos</label>
									<select id="tipo_viatico" className='form-control' defaultValue={formComision.tipo_viaticos} onChange={e => setFormComision({ ...formComision, tipo_viaticos: e.target.value })}>
										<option value={0} disabled>Selecciona una opción</option>
										<option value="Anticipados">Anticipados</option>
										<option value="Devengados">Devengados</option>
									</select>
								</div>
							</div>
							{/* vehículo autorizado */}
							<div className="col-md">
								<div className="mb-3">
									<label htmlFor="vehiculo_autorizado" className="fw-bold text-end d-flex flex-wrap">
										Vehículo autorizado
										<div className="fw-normal">&nbsp;(Opcional)</div>
									</label>
									<input
										type="text"
										id="vehiculo_autorizado"
										className="form-control"
										value={formComision.vehiculo_autorizado}
										onChange={e => setFormComision({ ...formComision, vehiculo_autorizado: e.target.value })} />
								</div>
							</div>
						</div>

						<div className="row gx-4 gy-3">
							<div className="col-md">
								{/* combustible */}
								<div className="mb-3">
									<label htmlFor="combustible" className="fw-bold text-end d-flex">
										Combustible
										<div className="fw-normal">&nbsp;(Opcional)</div>
									</label>
									<div className="input-group mb-3">
										<span className="input-group-text" id="basic-addon1">$</span>
										<input
											type="text"
											id="combustible"
											className="form-control"
											aria-label="combustible"
											aria-describedby="basic-addon1"
											value={formComision.combustible}
											onChange={e => setFormComision({ ...formComision, combustible: e.target.value })}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">

								{/* litros */}
								<div className="mb-3">
									<label htmlFor="litros" className="fw-bold text-end d-flex">
										Litros
										<div className="fw-normal">&nbsp;(Opcional)</div>
									</label>
									<input
										type="text"
										id="litros"
										className="form-control"
										value={formComision.litros}
										onChange={e => setFormComision({ ...formComision, litros: e.target.value })}
									/>
								</div>
							</div>

						</div>
						<div className="row gx-4 gy-3">
							<div className="col-md">
								{/* placas */}
								<div className="mb-3">
									<label htmlFor="placas" className="fw-bold text-end d-flex">
										Placas
										<div className="fw-normal">&nbsp;(Opcional)</div>
									</label>
									<input
										type="text"
										id="placas"
										className="form-control"
										value={formComision.placas}
										onChange={e => setFormComision({ ...formComision, placas: e.target.value })}
									/>
								</div>
							</div>
							<div className="col-md"></div>
						</div>
						{/* aquí termina el formulario */}

						<div className="text-center">

							<button className="btn btn-primary btn-block btn-lg" onClick={guardar} disabled={guardando}>
								{guardando ? 'Guardando' : 'Generar oficio'}
							</button>
						</div>

					</div>


				</div>
			</div>





			{/* modal */}
			<Modal show={show}>
				<Modal.Header>
					<Modal.Title>Documento listo</Modal.Title>
				</Modal.Header>
				<Modal.Body>El documento fue generado exitosamente. Puede cerrar esta ventana.</Modal.Body>
				<Modal.Footer>
					<Link to="/menu">
						<Button className="btn btn-primary">
							Salir
						</Button>
					</Link>
				</Modal.Footer>
			</Modal>



			<Toaster />
		</CardContenedor>
	)
}
